import { StyleSheet } from "./StyleSheet.js";
/**
 * Creates a `StyleSheet` containing a single rule that sets
 * the display property of the host element.
 */
// TODO: Rename for clarity
export function hostDisplay(display) {
    return StyleSheet.fromRules({
        host: {
            selector: ":host",
            styles: {
                display,
            },
        },
    });
}
